module.exports = __webpack_public_path__ + "img/ICON.68a99594.png";